import { ABOUT } from "../lib/content";

export default function About() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative py-24 md:py-32 lg:py-40 overflow-hidden text-white"
      style={{
        background: "radial-gradient(circle at center, #A370AF 0%, #7030A0 100%)",
      }}
    >
      <div className="absolute inset-0 grain pointer-events-none opacity-50" />
      <div className="pointer-events-none absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full blur-3xl opacity-30"
           style={{ background: "radial-gradient(circle, #FCFAFF 0%, transparent 70%)" }} />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        {/* Section label */}
        <div className="flex items-center gap-3 mb-10">
          <span className="font-body uppercase text-[11px] tracking-[0.32em] text-white font-bold">
            01 / Nosotros
          </span>
          <span className="flex-1 h-px bg-white/30" />
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-12">
          {/* Left: heading */}
          <div className="col-span-12 lg:col-span-5">
            <h2
              data-testid="about-heading"
              className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-white"
            >
              Una agencia<br />
              <span className="font-editorial italic font-light text-[#F0DCFA]">
                360°
              </span>{" "}
              donde<br />
              estética & estrategia<br />
              <span className="font-editorial italic font-light">se fusionan.</span>
            </h2>
          </div>

          {/* Right: paragraphs */}
          <div className="col-span-12 lg:col-span-7 lg:pl-8 flex flex-col gap-8 mt-2">
            <p
              data-testid="about-p1"
              className="font-body text-lg md:text-xl leading-[1.7] text-white"
            >
              {ABOUT.p1}
            </p>

            <div className="h-px w-16 bg-white/70" />

            <p
              data-testid="about-p2"
              className="font-body text-base md:text-lg leading-[1.75] text-white/85"
            >
              {ABOUT.p2}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
